import React from 'react';
import clsx from "clsx";
import ShowPackageCustomCategoryWeightRangeCostsButtonRowProperties from './ShowPackageCustomCategoryWeightRangeCostsButtonRowProperties';
import { useStyles } from '../ShowPackageCustomCategoryWeightRangeCostsButton.style';
import ShowText from '../../../Info/ShowText/ShowText';
import { useI18nContext } from '../../../../contexts/I18nContext';
import ShowIntervalWithTitle from '../../../Info/ShowIntervalWithTitle/ShowIntervalWithTitle';
import { CurrencyModule } from '../../../../util/Currency';
import Currency from '../../../../entities/Currency';

const ShowPackageCustomCategoryWeightRangeCostsButtonRowMedium: React.FC<ShowPackageCustomCategoryWeightRangeCostsButtonRowProperties> = ({
                                                            customCategoryWeinghtRangesPrice,
                                                        }) => {

    const classes = useStyles();
    const i18n = useI18nContext();

    return (
        <div
            className={clsx(classes.show_money_price_info_container)}>
            <ShowIntervalWithTitle title={i18n.translate("WEIGHT_RANGES_RANGE")} from={customCategoryWeinghtRangesPrice.from} to={customCategoryWeinghtRangesPrice.to}/>
            <ShowText text={CurrencyModule.format(customCategoryWeinghtRangesPrice.salePrice, Currency.DOLLAR)} title={i18n.translate("WEIGHT_RANGES_PRICE")}/>
        </div>
    )
}

export default ShowPackageCustomCategoryWeightRangeCostsButtonRowMedium;
